import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-90e775bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "by ", -1))
const _hoisted_2 = { class: "text-muted" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = { class: "d-flex mb-2" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_11 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_user_link = _resolveComponent("user-link")
  const _component_time_ago = _resolveComponent("time-ago")

  return (!$props.editing)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createElementVNode("h1", null, _toDisplayString($setup.post.title), 1),
        _hoisted_1,
        _createVNode(_component_user_link, {
          user: $setup.post.author
        }, null, 8, ["user"]),
        _createElementVNode("span", _hoisted_2, [
          _createVNode(_component_time_ago, {
            time: $setup.post.createdat
          }, null, 8, ["time"]),
          ($setup.post.editedat)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(" (edited"),
                _createVNode(_component_time_ago, {
                  time: $setup.post.editedat
                }, null, 8, ["time"]),
                _createTextVNode(")")
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _hoisted_3,
        _createVNode($setup["Markdown"], {
          html: $setup.post.renderedbody
        }, null, 8, ["html"]),
        _hoisted_4,
        _createVNode($setup["BottomSocials"], {
          "object-id": $setup.post.id,
          rating: $setup.post.rating
        }, null, 8, ["object-id", "rating"])
      ], 64))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            class: "form-control me-2",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.newTitle) = $event)),
            name: "newTitle",
            disabled: $setup.submittingEdit
          }, null, 8, _hoisted_6), [
            [_vModelText, $setup.newTitle]
          ]),
          _createElementVNode("button", {
            class: "btn btn-danger me-2",
            onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('finishedEdit'))),
            disabled: $setup.submittingEdit
          }, "Cancel", 8, _hoisted_7),
          _createElementVNode("button", {
            class: "btn btn-success",
            onClick: $setup.editPost,
            disabled: $setup.submittingEdit
          }, "Save", 8, _hoisted_8)
        ]),
        ($setup.editError)
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, "There was an error submitting your edit"))
          : _createCommentVNode("", true),
        _hoisted_10,
        _withDirectives(_createElementVNode("textarea", {
          class: "form-control",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.newBody) = $event)),
          rows: "10",
          name: "newBody",
          disabled: $setup.submittingEdit
        }, null, 8, _hoisted_11), [
          [_vModelText, $setup.newBody]
        ]),
        ($setup.submittingEdit)
          ? (_openBlock(), _createBlock($setup["LoadingOverlay"], { key: 1 }))
          : _createCommentVNode("", true)
      ], 64))
}